import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt="" style={{maxWidth:'100%'}}
                                                 src={require('@images/How to make timely decisions.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">


                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
isn't it interesting?
</span></div>
                                            <p>Imagine you’re a firefighter in a burning building… it could
                                                collapse at any second... you’re fighting
                                                the flames as you have been trained to… but there is
                                                something that strikes you, the way the
                                                flame is moving and not responding to your efforts to stop
                                                it spreading... how much time do you
                                                need to make a decision?</p>
                                            <div className="border_subtitle">The Conundrum</div>
                                            <div className="uiheading sep-space"><p>The human brain can
                                                register information within milliseconds so why do we need
                                                so much time
                                                to make some decisions, and how can we improve this?
                                                Firefighters are required to make quick
                                                decisions under pressure like few other professions need to
                                                – hesitation can cost lives. But how
                                                can you be sure that you are making the right decision?</p>
                                            </div>

                                            <div className="lightgreencontentbg">
                                                <div className="border_subtitle">Biases in decision making
                                                </div>
                                                <p>We make decisions by gathering information and using our
                                                    own beliefs and judgement to
                                                    make these as timely and effective as possible. In order
                                                    to make our lives easier we use
                                                    rules of thumb or ‘heuristics’<a
                                                        className="superscripttext"
                                                        href="further_info.php?course=300"><sup>1</sup></a> to
                                                    help solve problems, such as applying a specific rule to
                                                    a
                                                    range of examples. These guide our judgements and are
                                                    particularly useful when making
                                                    quick decisions. However, heuristics can lead to common
                                                    pitfalls that we need to be aware
                                                    of and avoid; for example, paying too much attention to
                                                    the first and last pieces of
                                                    information or attending to facts we want to whilst
                                                    ignoring others.</p>
                                                <div className="uiheading"><p>Our thinking processes may be
                                                    plagued by biases, but they can be hard to identify.
                                                    This is
                                                    because the biases are so widespread and natural that
                                                    they often feel like they fit. So when
                                                    making decisions think carefully about the information
                                                    that the judgement is based on in
                                                    order to avoid being biased.</p></div>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}